<template>
    <div>
        <div class="error-status"><img src="/static/image/error-icon.svg"></div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {

    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Channels/configurationButton/error-btn.vue